import View from "../../../Nav/Js/views/common/AudioPlayerView";
import components from "./components.js";
components.define("js-AudioPlayer", View);